import * as screens from '@screens';

const routes = Object.values(
    screens,
).map((route) => ({ component: route, path: route?.path }));

export default routes;
